import React from 'react';
import {Button} from "antd";
import OrangeButton from "./OrangeButton";
import classes from "./buttons.module.css";

const TransparentButton = (props) => {
    return (
        <Button {...props} className={classes.transparentBtn}>
            <span>{props.children}</span>
        </Button>
    );
};


TransparentButton.propTypes = {
    ...Button.propTypes, // Use Ant Design Button propTypes
};

export default TransparentButton;